import Slider from "rc-slider";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Modal } from "semantic-ui-react";
import { api, ui, utils } from "services";

export const CaptchaV2 = ({ cb, closeModal }: any) => {
    const { t } = useTranslation();
    const [amount, setAmount] = useState(0);
    const [loading, setLoading] = useState(false);
    const [id, setId] = useState(utils.create_UUID());
    const [imgBackground, setImgBackground] = useState("");
    const MAX_VALUE = 500 - 93;

    const getCaptcha = async () => {
        try {
            const res = await api.getCaptcha(id);
            const imageObjectURL = URL.createObjectURL(res);
            setImgBackground(imageObjectURL);
        } catch (err) {
            console.log({ err })
        }
    }

    const verifyCaptcha = async (amount: number) => {
        try {
            setLoading(true)
            const nonce = amount / MAX_VALUE
            await cb(id, nonce);
            closeModal();
        } catch (err: any) {
            setAmount(0);
            closeModal();
            ui.alertFailed("", t(err.message))
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        getCaptcha();
    }, [id])

    return (
        <Modal
            key={`captcha-modal`}
            open={true}
            style={{ width: "unset" }}
        >
            <div
                key={"captcha"}
                className="max-w-[540px] w-screen alert-popup bg-black-secondary"
            >
                {imgBackground && <div className="max-w-[540px] py-8 h-full w-screen relative center">
                    <div className="text-2xl text-white mb-10">
                        Please verify captcha to continue
                    </div>
                    <div className="max-w-[500px] relative">
                        <img src={imgBackground} alt="captcha-bg" className="w-[500px]" id="captcha-bg" />
                        <img src="/assets/images/slider.png" alt="slider" className="absolute w-[97px]" id="captcha-slider"
                            style={{
                                top: "100px",
                                transform: `translateX(${amount * 1}px)`
                            }}
                        />
                        {loading && <div className="absolute text-white top-[100px] mx-auto self-center justify-center w-full">
                            <div className="loader mx-auto"></div>
                        </div>}
                        <Slider
                            disabled={loading}
                            className="captcha-slider mt-4 mb-4"
                            min={0}
                            max={MAX_VALUE}
                            step={1}
                            value={amount}
                            onChange={(e) => {
                                setAmount(Number(e));
                            }}
                            trackStyle={{
                                background: "#E89F01"
                            }}
                            dotStyle={{
                                borderColor: "unset",
                                boxShadow: "unset",
                                border: "unset !important"
                            }}
                            activeDotStyle={{
                                borderColor: "unset",
                                boxShadow: "unset",
                                border: "unset !important"
                            }}
                            style={{
                                cursor: "pointer",
                                width: "100%"
                            }}
                            onAfterChange={async (e) => {
                                await verifyCaptcha(Number(e))
                            }}
                        />
                    </div>

                </div>}
                <div className="text-red cursor-pointer absolute -right-2 -top-2" onClick={() => {
                    if (!loading)
                        closeModal();
                }}>
                    <img src="/assets/images/icons/close-icon.svg" alt="close" className="" />
                </div>
            </div>
        </Modal>
    )
}